module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-47.5aeffaa4.svg";